<template>
  <div class="ren-decoration-cp ren-decoration-cp-floating-action" :class="positionClass">
    <small>{{ positionLabel }}</small>
    <button type="button" :style="buttonStyle">{{ displayText }}</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { numberValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const position = computed(() => {
  const value = String(props.component.props?.position ?? 'BOTTOM_RIGHT').toUpperCase()
  return value === 'BOTTOM_LEFT' ? 'BOTTOM_LEFT' : 'BOTTOM_RIGHT'
})
const positionClass = computed(() => (position.value === 'BOTTOM_LEFT' ? 'is-left' : 'is-right'))
const positionLabel = computed(() => (position.value === 'BOTTOM_LEFT' ? '左下示意' : '右下示意'))
const displayText = computed(() => {
  const label = stringValue(props.component.props?.label ?? props.component.props?.text).trim()
  if (label) return label
  const icon = stringValue(props.component.props?.icon).trim()
  if (!icon || icon === 'plus') return '+'
  return icon.length <= 2 ? icon : icon.slice(0, 1)
})
const buttonStyle = computed(() => {
  const style = props.component.style ?? {}
  const size = Number(style.size)
  return {
    backgroundColor:
      stringValue(style.backgroundColor) ||
      props.themeTokens?.primaryColor ||
      props.themeColor ||
      'var(--ren-theme-primary)',
    color: stringValue(style.textColor) || props.themeTokens?.buttonTextColor || '#fff',
    width: Number.isFinite(size) && size > 0 ? `${size}px` : undefined,
    height: Number.isFinite(size) && size > 0 ? `${size}px` : undefined,
    marginInline: numberValue(style.edgeOffset, 0) > 0 ? `${style.edgeOffset}px` : undefined
  }
})
</script>

<style scoped>
.ren-decoration-cp-floating-action {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ren-decoration-cp-floating-action.is-left {
  justify-content: flex-start;
}

.ren-decoration-cp-floating-action.is-right {
  justify-content: flex-end;
}

.ren-decoration-cp-floating-action small {
  color: var(--ren-theme-muted);
  font-size: 12px;
}

.ren-decoration-cp-floating-action button {
  min-width: 40px;
  min-height: 40px;
  border: 0;
  border-radius: 9999px;
  padding: 0 12px;
  font: inherit;
  cursor: default;
}
</style>
